import React, { useState, useEffect } from "react";
import InputText from "../../Inputs/Text";
import InputSelect from "../../Inputs/Select";
import RadioButton from "../../Inputs/Radio";
import { isOnlyNumbers } from "../../../utilities/Validations";

const transmisionOptions = [
  { value: "Manual", label: "Manual" },
  { value: "Automática", label: "Automática" },
];

const propietariosOptions = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5+", label: "5 o más" },
];

const TradeInSection = ({ onTradeInChange }) => {
  const [hasTradeIn, setHasTradeIn] = useState(null);
  const [carData, setCarData] = useState({
    marca: "",
    modelo: "",
    anioModelo: "",
    version: "",
    transmision: "",
    numeroPropietarios: "",
    color: "",
    kilometraje: "",
    pagosCorriente: null,
    todosDocumentos: null,
  });

  const updateField = (field, value) => {
    setCarData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (hasTradeIn === "si") {
      const data = {
        marca: carData.marca,
        modelo: carData.modelo,
        anioModelo: carData.anioModelo,
        version: carData.version,
        transmision: carData.transmision,
        numeroPropietarios: carData.numeroPropietarios !== "" ? parseInt(carData.numeroPropietarios) : 0,
        color: carData.color,
        kilometraje: carData.kilometraje !== "" ? parseInt(carData.kilometraje) : 0,
        pagosCorriente: carData.pagosCorriente === true,
        todosDocumentos: carData.todosDocumentos === true,
        pagando: carData.pagosCorriente === true,
      };
      onTradeInChange(data);
    } else {
      onTradeInChange(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTradeIn, carData]);

  const handleTradeInChange = (value) => {
    setHasTradeIn(value);
    if (value === "no") {
      setCarData({
        marca: "",
        modelo: "",
        anioModelo: "",
        version: "",
        transmision: "",
        numeroPropietarios: "",
        color: "",
        kilometraje: "",
        pagosCorriente: null,
        todosDocumentos: null,
      });
    }
  };

  return (
    <div className="trade-in-section mt-5 pt-5">
      <h3>Toma de auto</h3>
      <div className="trade-in-question mt-4">
        <p className="mb-3">¿Cuentas con un vehículo para toma de auto?</p>
        <div className="trade-in-radio-group">
          <RadioButton
            name="hasTradeIn"
            value="si"
            checked={hasTradeIn === "si"}
            onChange={() => handleTradeInChange("si")}
            label="Sí"
          />
          <RadioButton
            name="hasTradeIn"
            value="no"
            checked={hasTradeIn === "no"}
            onChange={() => handleTradeInChange("no")}
            label="No"
          />
        </div>
      </div>

      <div className={`trade-in-fields ${hasTradeIn === "si" ? "trade-in-fields--open" : ""}`}>
        <div className="fields-grid mt-4 mb-5">
          <div>
            <InputText
              label="Marca"
              name="tradeInMarca"
              secondaryLabel="Marca"
              maxLength={40}
              onBlur={(e) => updateField("marca", e.target.value.trim())}
            />
          </div>
          <div>
            <InputText
              label="Modelo"
              name="tradeInModelo"
              secondaryLabel="Modelo"
              maxLength={40}
              onBlur={(e) => updateField("modelo", e.target.value.trim())}
            />
          </div>
          <div>
            <InputText
              label="Año/Modelo"
              name="tradeInAnio"
              secondaryLabel="Año/Modelo"
              maxLength={4}
              value={carData.anioModelo}
              onChange={(e) => {
                if (e.target.value.length <= 4) {
                  updateField("anioModelo", isOnlyNumbers(e.target.value));
                }
              }}
            />
          </div>
          <div>
            <InputText
              label="Versión"
              name="tradeInVersion"
              secondaryLabel="Versión"
              maxLength={80}
              onBlur={(e) => updateField("version", e.target.value.trim())}
            />
          </div>
          <div>
            <InputSelect
              label="Transmisión"
              name="tradeInTransmision"
              options={transmisionOptions}
              onChange={(e) => updateField("transmision", e.target.value)}
              defaultValue={carData.transmision}
            />
          </div>
          <div>
            <InputSelect
              label="Número de propietarios"
              name="tradeInPropietarios"
              options={propietariosOptions}
              onChange={(e) => updateField("numeroPropietarios", e.target.value)}
              defaultValue={carData.numeroPropietarios}
            />
          </div>
          <div>
            <InputText
              label="Color"
              name="tradeInColor"
              secondaryLabel="Color"
              maxLength={30}
              onBlur={(e) => updateField("color", e.target.value.trim())}
            />
          </div>
          <div>
            <InputText
              label="Kilometraje"
              name="tradeInKilometraje"
              secondaryLabel="Kilometraje"
              maxLength={7}
              value={carData.kilometraje}
              onChange={(e) => {
                if (e.target.value.length <= 7) {
                  updateField("kilometraje", isOnlyNumbers(e.target.value));
                }
              }}
            />
          </div>
        </div>

        <div className="trade-in-extra-questions mt-4">
          <div className="trade-in-extra-question mb-4">
            <p className="mb-3">¿El auto cuenta con pagos al corriente?</p>
            <div className="trade-in-radio-group">
              <RadioButton
                name="pagosCorriente"
                value="si"
                checked={carData.pagosCorriente === true}
                onChange={() => updateField("pagosCorriente", true)}
                label="Sí"
              />
              <RadioButton
                name="pagosCorriente"
                value="no"
                checked={carData.pagosCorriente === false}
                onChange={() => updateField("pagosCorriente", false)}
                label="No"
              />
            </div>
          </div>
          <div className="trade-in-extra-question">
            <p className="mb-3">¿El auto cuenta con toda la documentación?</p>
            <div className="trade-in-radio-group">
              <RadioButton
                name="todosDocumentos"
                value="si"
                checked={carData.todosDocumentos === true}
                onChange={() => updateField("todosDocumentos", true)}
                label="Sí"
              />
              <RadioButton
                name="todosDocumentos"
                value="no"
                checked={carData.todosDocumentos === false}
                onChange={() => updateField("todosDocumentos", false)}
                label="No"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeInSection;
